import SpriteSymbol from "../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/_svg-sprite-loader@5.2.1@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_download",
  "use": "icon-icon_download-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol viewBox=\"0 0 14 14\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon_download\">\n<path d=\"M7 1.27271V9.70281\" stroke=\"\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n<path d=\"M0.583374 12.9393H13.4167\" stroke=\"\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n<path d=\"M2.72217 5.83899L6.99995 10.4053L11.2777 5.83899\" stroke=\"\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol